<div class="modal-header">
  <h5 class="modal-title">{{ options.title }} </h5>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col" *ngIf="options.date">
      <div class="row">
        <div class="col" [ngClass]="isSingle ? 'tc' : 'tr'">
          <ngb-datepicker #dp [(ngModel)]="initial.date" (ngModelChange)="onchange()" [startDate]="initial.date"></ngb-datepicker>
        </div>
      </div>
    </div>
    <div class="col" [ngClass]="isSingle ? 'tc' : 'tl'" *ngIf="options.time">
      <div class="row" [ngClass]="isSingle ? 'tc' : 'tl'">
        <div class="col pickerCenter">
          <ngb-timepicker class="pickerCenter" [seconds]="true" [(ngModel)]="initial.time" (ngModelChange)="onchange()"></ngb-timepicker>
        </div>
      </div>
      <div class="row">
        <div class="col" [ngClass]="isSingle ? 'tc' : 'tl'">
          <button (click)="startOfDay()" class="cursor-pointer btn btn-primary mr-2">
            {{ 'lang.time.startOfDay' |translate }}
          </button>
          <button (click)="endOfDay()" class="cursor-pointer btn btn-primary">
            {{ 'lang.time.endOfDay' |translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <sb-button classes="btn-primary" (click)="ok()">{{ 'lang.globals.ok' | translate }}
  </sb-button>
  <sb-button classes="btn-default" (click)="cancel()">{{ 'lang.globals.cancel' | translate }}
  </sb-button>
</div>
